<template>
  <div class="dashboard-block">
    <h2>Terms and condition & Privacy links</h2>

    <form>
      <div class="flex justify-between w-full">
        <div class="w-full spacer-r-2">
          <div :class="$hasErrorClass($v.stateTncLink, 'form-group')">
            <label class="control-label">Terms and conditions Link</label>
            <input
              name="tnc_link"
              type="text"
              class="form-control"
              v-model.lazy="$v.stateTncLink.$model"
              :disabled="uploading">

            <vuelidate-help label="Terms and conditions link" :field="$v.stateTncLink"/>
          </div>
        </div>
        <div class="w-full flex flex-row items-center spacer-t-1">
          <div class="spacer-r-2">
            OR
          </div>
          <div>
            <label for="tnc_upload">Upload Terms and Conditions</label>
            <input
              name="tnc_upload"
              id="tnc_upload"
              type="file"
              @change="(output) => { handleFileSelectionCallback(output, 'tnc_link') }">
          </div>
        </div>
      </div>
      <div class="flex justify-between w-full">
        <div class="w-full spacer-r-2">
          <div :class="$hasErrorClass($v.statePrivacyLink, 'form-group')">
            <label class="control-label">Privacy Link</label>
            <input
              name="privacy_link"
              type="text"
              class="form-control"
              v-model.lazy="$v.statePrivacyLink.$model"
              :disabled="uploading">
            <vuelidate-help label="Privacy link" :field="$v.statePrivacyLink"/>
          </div>
        </div>
        <div class="flex flex-row items-center spacer-t-1 w-full">
          <div class="spacer-r-2">
            OR
          </div>
          <div>
            <label for="privacy_link_upload">Upload Privacy Link</label>
            <input
              name="privacy_link_upload"
              id="privacy_link_upload"
              type="file"
              @change="(output) => { handleFileSelectionCallback(output, 'privacy_link') }">
          </div>
        </div>
      </div>

      <div class="flex justify-between w-full">
        <div class="w-full spacer-r-2">
          <div :class="$hasErrorClass($v.stateCollectionStatementLink, 'form-group')">
            <label class="control-label">Collection statement link</label>
            <input
              name="collection_statement_link"
              type="text"
              class="form-control"
              v-model.lazy="$v.stateCollectionStatementLink.$model"
              :disabled="uploading">

            <vuelidate-help label="Collection statement link" :field="$v.stateCollectionStatementLink"/>
          </div>
        </div>
        <div class="flex flex-row items-center spacer-t-1 w-full">
          <div class="spacer-r-2">
            OR
          </div>
          <div>
            <label for="collection_statement_upload">Upload Collection Statement</label>
            <input
              name="collection_statement_upload"
              id="collection_statement_upload"
              type="file"
              @change="(output) => { handleFileSelectionCallback(output, 'collection_statement') }">
          </div>
        </div>
      </div>

      <ladda-button
        class="btn btn-success"
        :click="handleSaveTncSettingsCallback">
        <i class="fa fa-check"></i> Save Changes
      </ladda-button>
    </form>
  </div>
</template>

<script>
import { url } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import { stateMapper } from 'mixins/settings'
import { pick } from 'lodash'
import { notify } from 'utils'
import VuelidateHelp from '../misc/VuelidateHelp'

export default {
  mixins: [stateMapper],

  components: { VuelidateHelp },

  validations: {
    stateTncLink: {
      url
    },
    statePrivacyLink: {
      url
    },
    stateCollectionStatementLink: {
      url
    }
  },

  data () {
    return {
      uploading: false
    }
  },

  methods: {
    ...mapActions('settings', ['updateSettings', 'uploadFile']),

    handleSaveTncSettingsCallback () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error(`Some fields failed validation. Please fix them and try again`)
        return Promise.resolve()
      }
      return this.updateSettings(pick(this.settings, [
        'tnc_link',
        'privacy_link'
      ]))
    },

    handleFileSelectionCallback ({ target: { files } }, fileType) {
      this.uploading = true
      if (files.length !== 0) {
        for (let i = 0; i < files.length; i++) {
          if (files[i].size >= 15000000) {
            notify.error('Maximum file size is 15MB. Unable to upload file: ' + files[i].name)
          } else {
            let file = files[i]

            let payload = {
              file: file,
              fileType
            }
            this.uploadFile(payload).then(response => {
              this.uploading = false
            }).catch((error) => {
              if (error.response && error.response.data.errors && error.response.data.errors.text && error.response.data.errors.text[0]) {
                notify.error(error.response.data.errors.text[0])
              } else {
                notify.error('Something went wrong uploading your file. Please try again.')
              }
              this.uploading = false
            })
          }
        }
      }
    }
  }
}
</script>
